
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.799 2.129c.032-.172.37-.172.403 0 .17.91.39 2.669.42 4.19.003.183.205.329.456.329.239 0 .437-.133.455-.307.066-.635.217-2.202.329-4.186.009-.159.313-.202.392-.053 1.229 2.302.972 6.055-1.006 7.154-.596.331-.898.87-.765 1.41.682 2.766 1.767 8.609 1.767 9.69C9.25 21.265 8.245 22 7 22s-2.25-.735-2.25-1.645c0-1.083 1.085-6.924 1.768-9.69.132-.538-.17-1.078-.766-1.409-1.977-1.1-2.234-4.852-1.005-7.154.079-.149.382-.106.391.053a93.35 93.35 0 00.329 4.186c.018.174.217.307.456.307.25 0 .452-.146.456-.329.029-1.521.25-3.28.42-4.19zm11.313-.083c.41-.147.888.078.888.412v3.815c0 2.025-.266 3.58-.552 4.671-.053.198-.052.4-.007.6.674 2.973 1.559 7.834 1.559 8.81C20 21.265 18.995 22 17.75 22s-2.25-.735-2.25-1.646c0-.883.721-4.929 1.357-7.895a1.838 1.838 0 00-.218-1.321C15.876 9.809 15 7.925 15 6.273c0-1.867 1.448-3.633 3.112-4.227z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    